import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-siblings',
  templateUrl: './siblings.component.html',
  styleUrls: ['./siblings.component.scss']
})
export class SiblingsInfoComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		this.deceased.siblings_info = true;

		// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

  ngOnInit() {
  }

}
